import * as Sentry from "@sentry/react";
import { getLoggedinUserId } from "services/auth";
import cumulativeErrorMessageUtil from "./cumulative-error-message-util";
import {
  ErrorMessages,
  ErrorTypes,
  SentryErrorSources,
  SentryTags
} from "../../constants";

export interface HandleErrorOptions {
  error: any;
  showError?: boolean;
  errorSource?: typeof SentryErrorSources[keyof typeof SentryErrorSources];
}

export default function ErrorManager() {
  const errorMapper = [
    {
      matchError: (errorStr: string) => {
        return ErrorTypes.netWorkError(errorStr);
      },
      errorMsg: ErrorMessages.NetworkError.offlineMessage
    },
    {
      matchError: (errorStr: string) => {
        return ErrorTypes.fieldNotFound(errorStr);
      },
      errorMsg: ErrorMessages.FieldNotFoundMessage
    }
  ];

  const handleError = (options: HandleErrorOptions) => {
    const { error, showError = true, errorSource = "unknown" } = options;

    if (!error) {
      Sentry.captureMessage("handleError called with undefined/null error");
      return null;
    }

    const errorStr = error.response?.data?.error || error?.message;
    let errorMsg = null;

    if (showError) {
      errorMapper.every((errorTypeObj) => {
        if (errorTypeObj.matchError(errorStr)) {
          errorMsg = errorTypeObj.errorMsg;
          return false;
        }
        return true;
      });

      if (!errorMsg) {
        errorMsg = ErrorMessages.DefaultFailureMessage;
      }

      cumulativeErrorMessageUtil.showError(errorMsg);
    }

    Sentry.captureException(error, {
      tags: {
        [SentryTags.error_source]: errorSource,
        [SentryTags.user_id]: getLoggedinUserId() || "unknown"
      }
    });
    return errorStr;
  };

  return { handleError };
}
